const featuresData = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持4K超高清画质播放，精细还原电影每一帧的视觉细节，让观影体验更沉浸、更震撼。悟空影视最新电影全部以最高画质呈现。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '即点即播',
    desc: '无需等待缓冲，点击即可流畅播放。采用先进的视频传输技术，无论网络环境如何都能保证稳定流畅的观影体验。',
  },
  {
    icon: 'ri-movie-line',
    title: '海量片库',
    desc: '悟空影视电影大全涵盖20000+部影片，从经典到新片、从动作到喜剧，满足各类影迷的多样化观影需求，片库每日持续更新。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-shield-star-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            平台优势
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          为什么选择悟空影视作为您的在线观影平台
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-400`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}